import { Link, useSearchParams } from 'react-router-dom';
import RegisterForm from './RegisterForm';
import TeacherJoinPage from './TeacherJoinPage';

export default function RegisterPage() {
  const [searchParams] = useSearchParams();
  const teacherParam = (searchParams.get('teacher') || '').trim();

  if (teacherParam) {
    return <TeacherJoinPage />;
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h2>Регистрация</h2>
        <p className="auth-subtitle">Создайте аккаунт для начала обучения</p>
        <RegisterForm />
        <p className="auth-link">
          Уже есть аккаунт? <Link to="/login">Войти</Link>
        </p>
      </div>
    </div>
  );
}
